import { getImageUrl } from '~/lib/image/getImageUrl'
import { Campaign } from './getTeamCampaign'

export default function HeroImage({
  campaign,
  children,
  hejaImagesBaseUrl,
}: {
  children?: React.ReactNode
  campaign: Campaign
  hejaImagesBaseUrl: string
}) {
  return (
    <div
      className={[
        'w-full flex flex-col relative z-10',
        campaign.heroImage ? 'bg-black h-full min-h-[200px] md:min-h-[500px]' : 'bg-primary-color',
      ].join(' ')}
    >
      {campaign.heroImage && (
        <div
          className="absolute z-10 top-0 left-0 right-0 bottom-0 opacity-60 bg-cover bg-center bg-no-repeat w-full h-full"
          style={{
            backgroundImage: `url(${getImageUrl({ url: campaign.heroImage, width: 1024, height: 500, hejaImagesBaseUrl })}`,
          }}
        />
      )}

      <div className="py-16 px-4 w-full flex flex-1 flex-col justify-center items-center gap-4">
        {campaign.name && <h2 className="text-white text-xl z-20">{campaign.name}</h2>}
        <h1 className="md:text-6xl font-bold leading-tight text-white z-20">
          {campaign.teamDisplayName || campaign.team.name}
        </h1>

        {children}
      </div>
    </div>
  )
}
